<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SubscriptionDuplicate" });
import { Icon } from "../../../../index.js";
import { createEventDispatcher } from "svelte";
import * as API from "../../services/api.js";
import { addMessage } from "../../../../stores/messages.js";
import { USER_KEY } from "../../../authentication/services/store.js";
import { get } from "svelte/store";
export let subscription = void 0;
const dispatch = createEventDispatcher();
const buildRequestBody = (subscription2) => {
    const { _, name, ...REST } = subscription2;
    REST.ownerKey = get(USER_KEY) ?? "";
    return REST;
};
const duplicateSubsciption = async () => {
    if (subscription === void 0) {
        return;
    }
    const BODY = buildRequestBody(subscription);
    const RESPONSE = await API.createSubscription(BODY);
    if (RESPONSE !== null && "code" in RESPONSE) {
        return;
    }
    addMessage({
        heading: "Preferences created successfully.",
        type: "success"
    });
    dispatch("save", RESPONSE);
};
</script>

<Icon key = 'copy' label = 'Duplicate' on:click = { duplicateSubsciption } />